import React from 'react';
import { Projects } from 'components';

export default ({ pageContext: { id, category, feed } }) => {
  return <Projects id={id} category={category} list={feed} />;
};
